@if (!isMobile) {
  <app-table>
    <table
      cdk-table
      [dataSource]="damages"
      >
      <caption class="visually-hidden">
        {{translations.labelDamages}}
      </caption>
      <ng-container cdkColumnDef="index">
        <th cdk-header-cell id='index-column-header' *cdkHeaderCellDef class="text-nowrap">
        </th>
        <td cdk-cell [attr.aria-label]="" *cdkCellDef="let damage, index as i">{{ i+1 }}.
        </td>
      </ng-container>
      <ng-container cdkColumnDef="type">
        <th cdk-header-cell id='type-column-header' *cdkHeaderCellDef class="text-nowrap">{{translations.tableHeaderType}}</th>
        <td cdk-cell *cdkCellDef="let damage">{{ damage.type }}</td>
      </ng-container>
      <ng-container cdkColumnDef="location">
        <th cdk-header-cell id='location-column-header' *cdkHeaderCellDef>{{translations.tableHeaderLocation}}<th>
          <td cdk-cell *cdkCellDef="let damage">{{ damage.location }}</td>
        </ng-container>
        <ng-container cdkColumnDef="excessWear">
          <th cdk-header-cell id='excess-wear-column-header' *cdkHeaderCellDef>{{translations.tableHeaderExcessWear}}</th>
          <td cdk-cell *cdkCellDef="let damage">{{ getExcessWear(damage) }}</td>
        </ng-container>
        <ng-container cdkColumnDef="estimatedCost">
          <th cdk-header-cell id='estimated-cost-column-header' *cdkHeaderCellDef>{{translations.tableHeaderEstimatedCost}}</th>
          <td cdk-cell *cdkCellDef="let damage">{{ formatCurrency(damage.repairEstimate.totalPrice) }}</td>
        </ng-container>
        <ng-container cdkColumnDef="description">
          <th cdk-header-cell id='description-column-header' *cdkHeaderCellDef>{{translations.tableHeaderDescription}}</th>
          <td cdk-cell *cdkCellDef="let damage">{{ damage.description }}</td>
        </ng-container>
        <tr cdk-header-row *cdkHeaderRowDef="columns"></tr>
        <tr cdk-row *cdkRowDef="let damages; columns: columns; even as even" [ngClass]="even ? 'row-even' : 'row-odd'"></tr>
      </table>
    </app-table>
  }
  @if (isMobile) {
    @for (damage of damages; track damage; let i = $index) {
      <app-table-card class="report-content-damages-table">
        <app-table-card-header class="report-content-damages-table-header">
          <div class="damages-card-header__title">
            <p class="fw-bold" [attr.aria-label]="index"
            > {{ i+1 }}.</p>
          </div>
        </app-table-card-header>
        <app-table-card-body>
          <dl class="damages-card__info-list">
            <div class="damages-card-body__col">
              <div class="column-grouping">
                <dt>{{translations.tableHeaderType}}:</dt>
                <dd>
                  <span>{{ damage.type }}</span>
                </dd>
              </div>
            </div>
            <div class="damages-card-body__col">
              <div class="column-grouping">
                <dt>{{translations.tableHeaderEstimatedCost}}:</dt>
                <dd>
                  <span>{{ formatCurrency(damage.repairEstimate.totalPrice) }}</span>
                </dd>
              </div>
            </div>
            <div class="damages-card-body__col">
              <div class="column-grouping">
                <dt>{{translations.tableHeaderExcessWear}}:</dt>
                <dd>
                  <span>{{ getExcessWear(damage) }}</span>
                </dd>
              </div>
            </div>
          </dl>
        </app-table-card-body>
        <app-table-card-body>
          <div class="special-column-grouping">
            <dt>{{translations.tableHeaderLocation}}:</dt>
            <dd>
              <span>{{ damage.location }}</span>
            </dd>
          </div>
          <div class="special-column-grouping">
            <dt>{{translations.tableHeaderDescription}}:</dt>
            <dd>
              <span>{{ damage.description }}</span>
            </dd>
          </div>
        </app-table-card-body>
      </app-table-card>
    }
  }
